import React, { useEffect, useState } from 'react';
import useAmplitude from 'utils/hooks/useAmplitude';
import ExtendedModal from 'components/Shared/Modal/index.js';
import WelcomeModal from 'components/Shared/WelcomeModal';
import CorporateClientForm from 'components/Shared/CorporateClient/CorporateClientForm';
import { RegistrationFlow } from 'constants/selfRegistration';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import useRegisterCorporationModal from './useRegisterCorporationModal';
import RegisterCorporationFormHeader from './RegisterCorporationFormHeader';
import CorporateClientRegistrationFormV2 from './CorporateClientRegistrationFormV2';
import CreditAccountCorporationRegistration from './CreditAccountCorporationRegistration';

import styles from './style.module.scss';

const RegisterCorporationModal = () => {
  const {
    isMobile,
    isRegisterCorporationLoading,
    isRegisterCorporationSuccess,
    isRegisterCreditAccountCorporationLoading,
    isRegisterCreditAccountCorporationSuccess,
    isGetCorporateClientPlaceholderLoading,
    registrationFlow,
    countryCode,
    prospectUser,
    onRegister,
    onCreditAccountCorporationRegister,
  } = useRegisterCorporationModal();

  const [isWelcomeModalVisible, setIsWelcomeModalVisible] = useState(true);
  const { sendAmplitudeEvent } = useAmplitude();

  const isRegistrationSuccess =
    isRegisterCorporationSuccess || isRegisterCreditAccountCorporationSuccess;

  const viewByFlow = {
    [RegistrationFlow.SELF_V1]: (
      <>
        <RegisterCorporationFormHeader />
        <CorporateClientForm
          isMobile={isMobile}
          isLoading={isRegisterCorporationLoading}
          isRegister={true}
          onSubmit={onRegister}
        />
      </>
    ),
    [RegistrationFlow.SELF_V2_UK]: (
      <CreditAccountCorporationRegistration
        onSubmit={onCreditAccountCorporationRegister}
        isLoading={isRegisterCreditAccountCorporationLoading}
      />
    ),
    [RegistrationFlow.SELF_V2_NON_UK]: (
      <>
        <RegisterCorporationFormHeader />
        <CorporateClientRegistrationFormV2
          isMobile={isMobile}
          isLoading={isRegisterCorporationLoading}
          onSubmit={onRegister}
          countryCode={countryCode}
        />
      </>
    ),
  };

  const paddingByFlow = {
    [RegistrationFlow.SELF_V1]: null,
    [RegistrationFlow.SELF_V2_UK]: styles.modalPadding_registrationInfo,
    [RegistrationFlow.SELF_V2_NON_UK]: styles.modalPadding_registrationForm,
  };

  useEffect(() => {
    prospectUser &&
      sendAmplitudeEvent(
        AMPLITUDE_EVENT_TYPES.selfRegistrationCorporateClientRegistrationPageViewed,
      );
  }, [prospectUser, sendAmplitudeEvent]);

  const RegisterCorporationFormModal = () => (
    <ExtendedModal
      visible={!isGetCorporateClientPlaceholderLoading && prospectUser}
      closable={false}
      footer={null}
      wrapClassName={'modalWrapper'}
      width={countryCode ? 565 : 630}
      className={paddingByFlow[registrationFlow]}
    >
      {viewByFlow[registrationFlow]}
    </ExtendedModal>
  );

  return (
    <>
      {RegisterCorporationFormModal()}
      {isRegistrationSuccess && !isMobile && (
        <WelcomeModal isVisible={isWelcomeModalVisible} setIsVisible={setIsWelcomeModalVisible} />
      )}
    </>
  );
};

export default RegisterCorporationModal;
